"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var usehooks_ts_1 = require("usehooks-ts");
/**
 * This hook returns true if current screen size is greater than/equal target breakpoint
 * example: md: 900, 900 -> true, 899 -> false
 */
function useIsBreakpoint(breakpoint) {
    var theme = (0, react_1.useTheme)();
    return (0, usehooks_ts_1.useMediaQuery)(theme.breakpoints.up_custom(breakpoint));
}
exports.default = useIsBreakpoint;
